export default __webpack_public_path__ + "./images/modal-arrow.5a69cacb.svg";